import React from 'react';
import { InfoOutlined } from 'jl-design-system/components/icons/InfoOutlined';
import { HelpOutlined } from 'jl-design-system/components/icons/HelpOutlined';
import { ServicesOutlined } from 'jl-design-system/components/icons/ServicesOutlined';

import styles from './Icon.scss';
import { formatTestId } from '../../../../utils/test-id/format-testid';

const mobileNavIconMap = {
  Help: HelpOutlined,
  'Services & Experiences': ServicesOutlined,
};

export const Icon = ({ label }: { label: string }) => {
  const Component = mobileNavIconMap[label];

  if (!Component) {
    return <InfoOutlined className={styles.icon} dataTestId="nav-icon-info" />;
  }
  return (
    <Component
      className={styles.icon}
      dataTestId={`${formatTestId(label, 'nav-icon-')}`}
    />
  );
};
